import { err, ok, Result, Unit } from "../result";
import { ProblemDetails } from "../models/Http";
import { get, post, put } from "./api";
import {
  UserOrder,
  UserOrderId,
  UserOrderType,
  UserOrderWriteModel
} from "../models/User";

export const listActiveOrders = async (
  type: UserOrderType
): Promise<Result<ProblemDetails, ReadonlyArray<UserOrder>>> => {
  const response = await get(`/v1/users/all/orders/active`, { type });
  const content = await response.json();

  if (response.ok) {
    return ok(content as ReadonlyArray<UserOrder>);
  }

  return err(content as ProblemDetails);
};

export const getOrder = async (
  id: UserOrderId
): Promise<Result<ProblemDetails, UserOrder>> => {
  const response = await get(`/v1/users/any/orders/${id}`);
  const content = await response.json();

  if (response.ok) {
    return ok(content as UserOrder);
  }

  return err(content as ProblemDetails);
};

export const updateOrder = async (
  order: UserOrderWriteModel
): Promise<Result<ProblemDetails, Unit>> => {
  const response = await put(
    `/v1/users/${order.userId}/orders/${order.id}`,
    order
  );

  if (response.ok) {
    return ok({} as Unit);
  }
  const content = await response.json();
  return err(content as ProblemDetails);
};

export const openPickupBoxes = async (
  order: UserOrder
): Promise<Result<ProblemDetails, Unit>> => {
  const response = await post(
    `/v1/users/${order.user.id}/orders/${order.id}/open-pickup-boxes`
  );

  if (response.ok) {
    return ok({} as Unit);
  }
  const content = await response.json();
  return err(content as ProblemDetails);
};
